import React from 'react'
import Helmet from 'react-helmet'
import './job-post.css'
import { withPrefix } from 'gatsby-link'
import { Link } from 'react-router-dom'
import avatar from '../assets/avatar.png'

const utils = require('../../utils')

export default ({ data }) => {
  const post = data.jobsJson
  const hue = Math.round(
    Math.abs(
      ((post.company ? post.company.length : 10) *
        (Math.ceil(1) - Math.floor(36)) +
        1) *
        20
    )
  )
  const truncate = (str, length, ending) => {
    if (length == null) {
      length = 100
    }
    if (ending == null) {
      ending = '...'
    }
    if (str.length > length) {
      return str.substring(0, length - ending.length) + ending
    } else {
      return str
    }
  }
  const stripTags = str => {
    const stripped = str.replace(/<\/?[^>]+(>|$)/g, '')
    const tidy = stripped.replace(/\r?\n|\r/g, ' ')
    return tidy
  }
  return (
    <div>
      <Helmet
        title={`${post.title} | ZAPGIGS`}
        meta={[
          { name: 'keywords', content: post.tags },
          {
            name: 'description',
            content: truncate(stripTags(post.description), 256, '...'),
          },
          { property: 'og:title', content: `${post.title} | ⚡ZAPGIGS` },
          { property: 'og:site_name', content: '⚡ZAPGIGS' },
          { property: 'og:type', content: 'website' },
          { name: 'twitter:card', content: 'summary' },
          { name: 'twitter:site', content: '@zapgigsHQ' },
          { name: 'twitter:creator', content: '@zapgigsHQ' },
          {
            name: 'twitter:url',
            content: `https://www.zapgigs.com/${post.slug}`,
          },
          {
            property: 'og:image',
            content: post.company_logo
              ? `https:${post.company_logo}`
              : `https://www.zapgigs.com${avatar}`,
          },
          {
            property: 'og:url',
            content: `https://www.zapgigs.com/${post.slug}`,
          },
          {
            property: 'og:description',
            content: truncate(stripTags(post.description), 256, '...'),
          },
        ]}
      />
      <Link to="/" className="back-link">
        ← back to search
      </Link>
      <div className="job-post">
        <div
          dangerouslySetInnerHTML={{
            __html: `<script type="application/ld+json">
        {
          "@context" : "http://schema.org/",
          "@type" : "JobPosting",
          "title" : "${post.title}",
          "description" : "${truncate(
            stripTags(post.description),
            256,
            '...'
          )}",
          "jobLocation" : "${post.location}",
          "datePosted":"${post.date}",
          "identifier": {
            "@type": "PropertyValue",
            "name": "${post.company}",
            "value": "${post.id}"
          },
          "employmentType" : "FULLTIME",
          "hiringOrganization" : {
            "@type" : "Organization",
            "name" : "${post.company}"
          }
        }
        </script>`,
          }}
        />
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              flex: 0,
              lineHeight: 1,
              fontFamily: 'monospace',
            }}
          >
            {post.company_logo ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  margin: '0 auto',
                  background: `url(${post.company_logo})`,
                  backgroundPosition: 'center',
                  backgroundSize: 'contain',
                  backgroundRepeat: 'no-repeat',
                  fontSize: '3em',
                  padding: '.25em .5em',
                  height: '5rem',
                  width: '5rem',
                  borderRadius: '.25rem',
                }}
              />
            ) : (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  margin: '0 auto',
                  background: `linear-gradient(45deg,hsl(${hue}, 50%, 60%), hsl(${hue}, 50%, 40%))`,
                  color: 'white',
                  fontSize: '4em',
                  padding: '.25em .5em',
                  lineHeight: '1',
                  height: '5rem',
                  width: '5rem',
                  textTransform: 'uppercase',
                  borderRadius: '.25rem',
                }}
              >
                {post.company ? post.company.charAt(0) : '?'}
              </div>
            )}
            <div style={{ fontFamily: 'monospace', marginTop: '.5rem' }}>
              {post.company}
            </div>
          </div>
          <h1
            className="job-post__title"
            style={{ flex: '1', alignSelf: 'center', margin: '2rem 0' }}
          >
            {post.title}
          </h1>

          <div
            className="job-post__meta"
            style={{
              flex: '0 0 100%',
              fontFamily: 'monospace',
            }}
          >
            <span style={{ display: 'inline-block' }}>{post.date_pretty}</span>
            &nbsp;|&nbsp;
            <span style={{ display: 'inline-block' }}>
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 100 100"
                  style={{ width: '0.8em' }}
                >
                  <path
                    d="M52.768 0C33.749 0 18.333 15.417 18.333 34.434a34.268 34.268 0 0 0 4.203 16.494c.082.372 26.947 47.042 26.947 47.042a3.796 3.796 0 0 0 3.284 1.896 3.802 3.802 0 0 0 3.283-1.896s26.863-46.669 26.946-47.041a34.257 34.257 0 0 0 4.203-16.495C87.2 15.417 71.784 0 52.768 0zm0 52.776c-8.55 0-15.48-6.932-15.48-15.48 0-8.549 6.93-15.479 15.48-15.479 8.548 0 15.478 6.93 15.478 15.479-.001 8.549-6.931 15.48-15.478 15.48z"
                    fill="#47596b"
                  />
                </svg>
              </span>{' '}
              {post.location}
            </span>
            <div style={{ marginTop: '1rem' }}>
              {post.tags
                ? post.tags.map((tag, i) => {
                    return (
                      <span className="tag" key={i}>
                        {tag}
                      </span>
                    )
                  })
                : ''}
            </div>
          </div>
        </div>
        <div
          className="job-post__body"
          dangerouslySetInnerHTML={{
            __html: utils.entities.decode(post.description),
          }}
        />
        <a
          href={`${post.url}?utm_source=www.zapgigs.com`}
          target="_blank"
          className="button"
          target="_blank"
        >
          Apply on {post.source.name} →
        </a>
      </div>
    </div>
  )
}

export const query = graphql`
  query BlogPostQuery($slug: String!) {
    jobsJson(slug: { eq: $slug }) {
      id
      slug
      date
      date_pretty
      company
      company_logo
      tags
      title
      description
      location
      url
      source {
        name
        homepage
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/job-post.js